import useSSE from "../../hooks/useSSE";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by MeetingDetailsProvider, to provide centralized state management and logic control

export default function useParticipantsSSE({ participantsEventSourceRef, meeting, store }) {
  useSSE(participantsEventSourceRef, meeting && `/lw/${meeting.mid}/participants/sse`, {
    invited: (participant) => {
      console.log("PSSE: invited", participant);
      store.participants !== null && store.updateParticipantsWithInvited(participant);
    },
    "status-changed": ({ status, pid }) => {
      console.log("PSSE: status-changed", { status, pid });
      // status can be: joining, joined, leaving, left
      store.participants !== null && store.updateParticipantsWithStatusChanged({ status, pid });
    },
    uninvited: ({ pid }) => {
      console.log("PSSE: uninvited", { pid });
      store.participants !== null && store.removeUninvitedParticipant({ pid });
    },
    audio: ({ mute, pid }) => {
      console.log("PSSE: audio", { mute, pid });
      store.participants !== null && store.updateParticipantAudio({ mute, pid });
    },
    video: ({ mute, pid }) => {
      console.log("PSSE: video", { mute, pid });
      store.participants !== null && store.updateParticipantVideo({ mute, pid });
    },
  });
}
